import { ErrorAlert } from "@containers/common/error-alert/error-alert"
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count"

export const getTabTitle = (tabName: string, count: number) => {
    return <TabTitleWithErrorCount tabName={tabName} errorCount={count} />
}

export const getErrorAlert = (message: React.ReactNode, id?: string) => {
    return <ErrorAlert id={id}><span>{message}</span></ErrorAlert>
}